import { ALL_ANIMAL_LISTING_SUCCESS } from './actionType'

//

const INIT_STATE = {
  BreedList: [],
  loading: true,
  error: {},
}

const EasyFiedsAnimalReducer = (state = INIT_STATE, action) => {
  const { type, payload } = action
  switch (type) {
    case ALL_ANIMAL_LISTING_SUCCESS:
      return {
        ...state,
        BreedList: payload,
        loading: false,
      }

    default:
      return state
  }
}

export default EasyFiedsAnimalReducer
